<template>
  <WrappedForm
    ref="form"
    class="group-editor"
    label-position="top"
    label-bold
    hide-required-asterisk
    :model="groupData"
    :formLines="formLines"
  >
  </WrappedForm>
</template>

<script>
import WrappedForm from '@/components/formEditor/wrappedForm.vue'
import { i18nPrefix } from './common'

export default {
  components: {
    WrappedForm
  },
  props: {
    isEdit: {
      type: Boolean,
      required: true
    },
    group: {
      required: false
    }
  },
  data () {
    return {
      i18nPrefix,
      groupData: {
        id: null,
        name: null,
        cn_name: null
      }
    }
  },
  computed: {
    form () {
      return this.$refs.form
    },
    groupWatcher () {
      return this.group
    },
    formLines () {
      const requiredMessage = this.$t('common.message.requiredFormField')
      const lines = {
        name: {
          label: this.$t(`${this.i18nPrefix}.label.groupName`),
          rules: [
            { required: true, message: requiredMessage, trigger: 'blur' }
          ]
        },
        cn_name: {
          hidden: true,
          label: this.$t(`${this.i18nPrefix}.label.groupName`),
          rules: [
            { required: true, message: requiredMessage, trigger: 'blur' }
          ]
        }
      }
      return lines
    }
  },
  created () {
    this.groupData = this.toData(this.group)
  },
  methods: {
    parse (groupData) {
      if (!groupData) {
        groupData = this.groupData
      }
      return {
        id: groupData.id,
        name: groupData.name,
        cn_name: groupData.name
      }
    },
    toData (group) {
      if (group) {
        return { ...group }
      } else {
        return {
          id: null,
          name: null,
          cn_name: null
        }
      }
    },
    clearData () {
      this.groupData = this.toData(null)
      this.$nextTick(() => this.clearValidate())
    },
    clearValidate () {
      this.form.clearValidate()
    },
    async submit () {
      const isValid = await this.form.submit()
      if (!isValid) {
        return null
      } else {
        return this.parse(this.groupData)
      }
    }
  },
  watch: {
    groupWatcher () {
      this.groupData = this.toData(this.group)
      this.$nextTick(() => this.clearValidate)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
